const ajaxLink = (el, { value, modifiers, expression }, { Alpine, effect, cleanup }) => {

    effect(() => {

        if(!value){
            console.log('The parameter value is missing, which should be the id of the form.');
        }

        if(!modifiers[0]) {
            console.warn('The parameter modeifier is missing, which should be the name of the input field.');
        }

        el.onclick = (e) => {
            e.preventDefault();

            document.querySelector(`input[name="${modifiers[0]}"]`).value = expression;;
            document.querySelector(`#${value}`).requestSubmit();
        };
    });

};

export { ajaxLink };